import "./App.css";
import React from "react";
import ContactCardView from "./components/Contact";
import HeaderView from "./components/Header";
import LegalFAQView from "./components/LegalFAQ";
import TestimonialCarouselView from "./components/Testimonials";
import ServiceListView from "./components/ServiceList";
import MyTeamView from "./components/MyTeam/index";
import FooterView from "./components/Footer";
import Navbar from "./components/Navbar/Navbar";
import WelcomeView from "./components/Welcome";

function App() {
  const [requestSubmitted, setRequestSubmitted] = React.useState(
    localStorage.getItem("requestSubmitted")
  );
  React.useEffect(() => {}, [requestSubmitted]);
  return (
    <>
      <Navbar/>
      <HeaderView requestSubmitted={requestSubmitted} setRequestSubmitted={setRequestSubmitted} />
      <WelcomeView/>
      <ServiceListView />
      <LegalFAQView />
      <MyTeamView />
      <TestimonialCarouselView requestSubmitted={requestSubmitted} setRequestSubmitted={setRequestSubmitted} />
      <ContactCardView />
      <FooterView />
    </>
  );
}

export default App;
